export default __webpack_public_path__ + "static/media/Henley.d1f84f4b.jpg";